import React, {useContext} from "react"

// context
import {FavouritesContext} from "../../context/FavouritesContext"

// styling and images
import images from "../../images"
import "./FavouriteToggle.scss"

/**
 * 
 * @param {*} activityId - Id of activity
 * @param {*} size - 'small' or 'large' (large does not display text) 
 */
const FavouriteToggle = ({activityId, size}) => {
  // get the shop context
  let favourites = useContext(FavouritesContext)

  // no activityId? no salsa!
  if(!activityId) {
    console.warn('no activityId prop provided to FavouriteToggle component')
    return null
  }

  // favourite
  let isFavourite = favourites.isFavourite(activityId)
  let text = isFavourite ? "aus Favoriten entfernen" : "zu Favoriten hinzufügen"
  let className1 = isFavourite ? "remove" : "add"
  let className2 = size
  let onClick = isFavourite ? favourites.remove : favourites.add
  let image = images.icons.heart_full_green
  if(!isFavourite) {
    image = size==="large" ? images.icons.heart_full_white : images.icons.heart_empty_green
  }

  let textSpan = size === "large" ? null : <span>{text}</span>

  return (
    <div className={`c-favouriteToggle ${className1} ${className2}`} onClick={() => {onClick(activityId)}}>
      <div>
        {textSpan}
        <img src={image} alt="add to favourites" />
      </div>
    </div>
  )
}

export default FavouriteToggle